<template>
    <div>
         <div class="search">
            <div style="display:flex">
               <el-button style="margin-right: 12px;" v-if="codeData.indexOf('330') != -1" @click="homeShoeVisible" type="primary">监测配置</el-button>
                <div  @click="openRules"  class="btn-two">监测规则</div>
            </div>
            <div>
                <a-range-picker v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
                <a-select
                showArrow
                allowClear
                v-model="stations"
                style="width: 200px; margin-right: 20px;margin-left:12px"
                placeholder="评估结果"
                >
                  <a-select-option value="0">合格</a-select-option>
                  <a-select-option value="1">不合格</a-select-option>
                </a-select>
                <el-button @click="search" type="primary">查询</el-button>
            </div>
            </div>
            <div class="table-box">
                <coententTable
              :y="height"
              @onShowSizeChange="onShowSizeChange"
              :columns="columns"
              :pagination="pagination"
              :dataSource="dataSource"
              :bordered='true'
              :loading="loading"
              :customSlot="customSlot"
              @handleSizeChange="handleSizeChange"
            >
             <template v-slot:notUpdateDay="scopeVal">
                <div  v-if="scopeVal.scope.status == 0">{{scopeVal.scope.notUpdateDay}}</div>
                <div class="status-txt-three" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.notUpdateDay}}</div>
                <div class="status-txt-two" v-if="scopeVal.scope.status == 2">{{scopeVal.scope.notUpdateDay}}</div>
            </template>
             <template v-slot:status="scopeVal">
                <div class="status-txt-one" v-if="scopeVal.scope.status == 0">合格</div>
                <div class="status-txt-three" v-if="scopeVal.scope.status == 1">警告</div>
                <div class="status-txt-two" v-if="scopeVal.scope.status == 2">不合格</div>
            </template>
              <template v-slot:operation="scopeVal">
                  <div v-if="codeData.indexOf('329') != -1" @click="openList(scopeVal.scope)" class="btnTwo">监测清单</div>
              </template>
            </coententTable>
            </div>
            <DetectionRules v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></DetectionRules>
            <HomeNotChecklist :itemData="itemData" v-if="dialogVisibleTwo" @handleClose="handleCloseTwo" :dialogVisible="dialogVisibleTwo"></HomeNotChecklist>
            <MonitoringConfiguration  @onClose="onClose" :visible="homeVisible"></MonitoringConfiguration>
    </div>
</template>
<script>
import {columnList} from '../index';
import coententTable from "@/components/coentent_table.vue";
import DetectionRules from "./detection_rules.vue";
import HomeNotChecklist from "./column_list.vue";
import MonitoringConfiguration from "./column_configuration.vue";
export default {
  components: {coententTable,DetectionRules,HomeNotChecklist,MonitoringConfiguration},
  data() {
    return {
      height: 0,
      loading: false,
      columns: [
        {
          title: "监测日期",
          dataIndex: "time",
          width: 200,
          ellipsis: true,
        },
        {
          title: "未按标准更新栏目数",
          dataIndex: "columnNumber",
          width: 200,
          ellipsis: true,
          children: [
                {
                    title: '动态要闻类',
                    dataIndex: 'dynamicNewsNumber',
                    width: 150,
                   
                },
                 {
                    title: '通知公告类',
                    dataIndex: 'noticeNumber',
                    width: 150,
                },
                 {
                    title: '政策文件类',
                    dataIndex: 'policyPaperNumber',
                    width: 150,
                },
                 {
                    title: '政策解读类',
                    dataIndex: 'policyInterpretationNumber',
                    width: 150,
                },
                {
                    title: '其他栏目',
                    dataIndex: 'otherNumber',
                    width: 150,
                },

           ]
        },
        {
          title: "扣分",
          dataIndex: "score",
          ellipsis: true,
           width: 100,
        },
        {
          title: "监测结果",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
          width: 200,
          ellipsis: true,
        },
        {
          title: "监测站点",
          dataIndex: "siteName",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 120,
          fixed: "right",
        },
      ],
      customSlot: [
        {
          name: "status",
          customRender: "status",
        },
        {
          name: "notUpdateDay",
          customRender: "notUpdateDay",
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      time: [],
      stations: undefined,
      dialogVisible:false,
      dialogVisibleTwo:false,
      itemData:{},
      homeVisible:false,
      codeData:[],
    };
  },

  mounted() {
    this.getList()
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    homeShoeVisible(){
        this.homeVisible = true;
    },
    onClose(){
       this.homeVisible = false;
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      columnList({
        current:this.pagination.current,
        size:this.pagination.pageSize,
        endTime:endTime,
        startTime:startTime,
        status:this.stations,
        siteId:sessionStorage.getItem('siteId')
      }).then((res)=>{
              if(res.code == 0){
              this.dataSource = res.data.records;
              this.pagination.current =  res.data.current;
              this.pagination.total =  res.data.total;
              if(this.pagination.total > 0){
                this.height = document.documentElement.clientHeight - 419;
                window.onresize = () => {
                    return (() => {
                      this.height = document.documentElement.clientHeight - 419;
                    })();
                  };
              }
              this.loading = false;
          }else{
            this.loading = false;
          }
      })
    },
    search() {
       this.pagination.current = 1;
       this.getList();
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
    openRules(){
      this.dialogVisible = true;
    },
    handleClose(){
        this.dialogVisible = false;
    },
    handleCloseTwo(){
      console.log('ssssssss')
        this.dialogVisibleTwo = false;
    },
    openList(item){
        this.itemData = item;
        this.dialogVisibleTwo = true;
        
    }
  },
};
</script>

<style lang="less" scoped>
.search {
  padding: 0 24px 0 24px;
  justify-content: space-between;
  display: flex;
  margin-top: 20px;
  /deep/ .ant-select-selection {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .ant-input {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .el-input__inner {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ input::-webkit-input-placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 39px;
  }
  /deep/ .el-select__tags {
    white-space: nowrap;
    overflow: hidden;
  }
  /deep/ .el-select__tags {
    flex-wrap: nowrap;
  }
}
/deep/ .el-tabs__header{
  margin: 0px;
}
.el-button--primary {
  background: #176de6;
}

.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 66px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-txt-one{
  color: rgba(103, 194, 58, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
}
.status-txt-two{
  color: rgba(245, 108, 108, 1);
  font-size: 14px;
  font-family: Microsoft Yahei;
}
.btn-two{
  width: 96px;
  height: 40px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1);
  display: flex;
  align-items: center;
  justify-content:center;
  color: rgba(23, 109, 230, 1);
  cursor: pointer;
}
.status-txt-three{
  background-color: rgba(255, 255, 255, 1);
  color: rgba(230, 162, 60, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
}
.table-box{
  /deep/ .ant-table-fixed{
    border: none;
    
  }
  /deep/ .ant-table-fixed-right .ant-table-fixed .ant-table-thead > tr > th{
      border-right: none !important;
    }
    /deep/ .ant-table-placeholder{
      border-top: none;
      border-left: none;
      border-right: none;
    }
}

</style>